import { Tabs } from "@mantine/core";
import { useContext, useMemo, useState } from "react";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import {
  IconUsers,
  IconMailForward,
  IconFileImport,
  IconPlus,
} from "@tabler/icons-react";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import Invitees from "../components/Registrations/Invites/Invitees";
import InviteComposer from "../components/Registrations/Invites/InviteComposer";
import ImportRecipientsModal from "../components/Registrations/Invites/ImportRecipientsModal";
import EditRecipientModal from "../components/Registrations/Invites/EditRecipientModal";

function InviteAttendees() {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("invitees");
  const [importOpen, setImportOpen] = useState(false);
  const [addRecipientOpen, setAddRecipientOpen] = useState(false);

  const currentEventId = getCurrentWorkspace(user).eventId;

  const actions = useMemo(
    () =>
      [
        activeTab === "invitees" && {
          label: "Add recipient",
          icon: <IconPlus />,
          onClick: () => setAddRecipientOpen(true),
        },
        activeTab === "invitees" && {
          label: "Import",
          icon: <IconFileImport />,
          onClick: () => setImportOpen(true),
        },
      ].filter(Boolean),
    [activeTab]
  );

  useSetActionButtons(actions);

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
      keepMounted={true}
      variant="outline"
    >
      <Tabs.List>
        <Tabs.Tab value="invitees" leftSection={<IconUsers size={16} />}>
          Invitees
        </Tabs.Tab>

        <Tabs.Tab
          value="invite-email"
          leftSection={<IconMailForward size={16} />}
        >
          Invite email
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel
        value="invitees"
        style={{ flex: 1, overflowY: "auto", padding: 16 }}
      >
        <Invitees eventId={currentEventId} />
      </Tabs.Panel>

      <Tabs.Panel
        value="invite-email"
        style={{ flex: 1, overflowY: "auto", padding: 16 }}
      >
        <InviteComposer eventId={currentEventId} />
      </Tabs.Panel>

      <ImportRecipientsModal
        opened={importOpen}
        onClose={() => setImportOpen(false)}
        eventId={currentEventId}
      />

      <EditRecipientModal
        opened={addRecipientOpen}
        onClose={() => setAddRecipientOpen(false)}
        eventId={currentEventId}
        recipient={null}
      />
    </Tabs>
  );
}

export default InviteAttendees;
